<template>
  <div class="analysis-page">
    <div class="analysis-header">
      <span class="header-title">{{ examinationSer }}</span>
      <el-button size="small" @click="$router.push('/task')">返回</el-button>
    </div>
    <div class="page analysis-body">
      <!-- 左侧面板 -->
      <div class="left-panel">
        <div class="user-profile">
          <img class="avatar" src="@/assets/img/icontouxiang.png" />
          <div class="user-info">
            <div class="uname">
              姓名: {{ userInfo.studentName || "未命名" }}
            </div>
            <div class="uno">学号: {{ userInfo.studentNo || "0000" }}</div>
          </div>
        </div>
        <el-collapse class="nav-collapse" accordion :value="subjectType">
          <el-collapse-item name="SingX" v-if="SingXList.length > 0">
            <template slot="title">单选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in SingXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'SingX' && subjectIndex === index,
                  answered: item.answer
                }"
                @click="
                  switchItem('SingX');
                  singxIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="MultX" v-if="MultXList.length > 0">
            <template slot="title">多选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in MultXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'MultX' && subjectIndex === index,
                  answered: item.fill
                }"
                @click="
                  switchItem('MultX');
                  multxIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="JudgX" v-if="JudgXList.length > 0">
            <template slot="title">判断题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in JudgXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'JudgX' && subjectIndex === index,
                  answered: item.answer
                }"
                @click="
                  switchItem('JudgX');
                  judgexIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="FillX" v-if="FillXList.length > 0">
            <template slot="title">填空题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in FillXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'FillX' && subjectIndex === index,
                  answered: item.answer
                }"
                @click="
                  switchItem('FillX');
                  fillxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="AnwsX" v-if="AnwsXList.length > 0">
            <template slot="title">解答题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in AnwsXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'AnwsX' && subjectIndex === index,
                  answered: item.answer
                }"
                @click="
                  switchItem('AnwsX');
                  anwsxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="ProofX" v-if="ProofXList.length > 0">
            <template slot="title">证明题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in ProofXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'ProofX' && subjectIndex === index,
                  answered: item.answer
                }"
                @click="
                  switchItem('ProofX');
                  proofxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 右侧题目区域 -->
      <div class="right">
        <div class="item" :key="subjectType + '-' + subjectIndex">
          <!-- 单选 -->
          <div
            class="title"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <div v-for="item in SingXList[subjectIndex].steam" :key="item.id">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span class="student-answer"
              >学生选择:{{ SingXList[subjectIndex].answer }}</span
            >
          </div>
          <div
            class="groupbox"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <div
              v-for="(item, index) in SingXList[subjectIndex].options"
              :key="index"
              :data-index="SingXList[subjectIndex].order[index]"
              :class="{ 'correct-option': item.correct }"
            >
              <div class="option-content">
                <span class="labelbox1"
                  >{{ orderList[index].label }}.{{ str }}</span
                >
                <span v-for="(t, i) in item.ranginfos" :key="i">
                  <span v-for="(it, j) in t.wordInfos" :key="j">
                    <span v-if="it.wdType === 1" v-katex>${{ it.latex }}$</span>
                    <img v-else-if="it.wdType === 2" :src="it.buffer" />
                    <span v-else>{{ it.content }}</span>
                  </span>
                </span>
                <span v-if="item.correct === true" class="correct-tag">
                  <img src="../../assets/img/dui.png" alt="" />正确答案</span
                >
              </div>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="(item, index) in SingXList[subjectIndex].solve"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 多选 -->
          <div
            class="title"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <div
              v-for="(item, index) in MultXList[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span class="student-answer"
              >学生选择:{{ MultXList[subjectIndex].fill }}</span
            >
          </div>
          <div
            class="groupcheckbox"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <div
              v-for="(item, index) in MultXList[subjectIndex].options"
              :key="index"
              :class="{ 'correct-option': item.correct }"
            >
              <div
                :label="orderList[index].label"
                class="el_radio option-content"
              >
                <span class="labelbox1"
                  >{{ orderList[index].label }}.{{ str }}</span
                >
                <span v-for="(t, i) in item.ranginfos" :key="i">
                  <span v-for="(it, j) in t.wordInfos" :key="j">
                    <span v-if="it.wdType === 1" v-katex>${{ it.latex }}$</span>
                    <img v-else-if="it.wdType === 2" :src="it.buffer" />
                    <span v-else>{{ it.content }}</span>
                  </span>
                </span>
                <span v-if="item.correct === true" class="correct-tag">
                  <img src="../../assets/img/dui.png" alt="" />正确答案</span
                >
              </div>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="(item, index) in MultXList[subjectIndex].solve"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 判断 -->
          <div
            class="title"
            v-if="subjectType === 'JudgX' && JudgXList.length > 0"
          >
            <div v-for="item in JudgXList[subjectIndex].steam" :key="item.id">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <span class="student-answer"
              >学生选择:{{ JudgXList[subjectIndex].answer }}</span
            >
          </div>
          <div v-if="subjectType === 'JudgX' && JudgXList.length > 0">
            <div
              :class="{ 'correct-option': JudgXList[subjectIndex].judge == 1 }"
            >
              <div class="option-content">
                <span class="box"
                  ><i
                    class="el-icon-circle-check"
                    :style="{
                      color: JudgXList[subjectIndex].judge == 1 ? '#ff4d4f' : ''
                    }"
                  ></i
                ></span>
                <span
                  v-if="JudgXList[subjectIndex].judge == 1"
                  class="correct-tag"
                >
                  <img src="../../assets/img/dui.png" alt="" />正确答案</span
                >
              </div>
            </div>
            <div
              :class="{ 'correct-option': JudgXList[subjectIndex].judge == 0 }"
            >
              <div class="option-content">
                <span class="box"
                  ><i
                    class="el-icon-circle-close"
                    :style="{
                      color: JudgXList[subjectIndex].judge == 0 ? '#ff4d4f' : ''
                    }"
                  ></i
                ></span>
                <span
                  v-if="JudgXList[subjectIndex].judge == 0"
                  class="correct-tag"
                >
                  <img src="../../assets/img/dui.png" alt="" />正确答案</span
                >
              </div>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="(item, index) in JudgXList[subjectIndex].solve"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 填空 -->
          <div
            class="title"
            v-if="subjectType === 'FillX' && FillXList.length > 0"
          >
            <div
              v-for="(item, index) in FillXList[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="item in FillXList[subjectIndex].solve"
              :key="item.id"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>

            <!-- 填空题附件展示 -->
            <div
              class="attachment-container"
              v-if="getAttachmentsByQid(FillXList[subjectIndex].qid).length > 0"
            >
              <div class="attachment-header">
                <i class="el-icon-picture-outline"></i>
                <span>我的附件</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="(file, index) in getAttachmentsByQid(
                    FillXList[subjectIndex].qid
                  )"
                  :key="index"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="
                      getAttachmentsByQid(FillXList[subjectIndex].qid).map(
                        v => v.url
                      )
                    "
                    fit="cover"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
          <!-- 解答 -->
          <div
            class="title"
            v-if="subjectType === 'AnwsX' && AnwsXList.length > 0"
          >
            <div
              v-for="(item, index) in AnwsXList[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="(item, index) in AnwsXList[subjectIndex].solve"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>

            <!-- 解答题附件展示 -->
            <div
              class="attachment-container"
              v-if="getAttachmentsByQid(AnwsXList[subjectIndex].qid).length > 0"
            >
              <div class="attachment-header">
                <i class="el-icon-picture-outline"></i>
                <span>我的附件</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="(file, index) in getAttachmentsByQid(
                    AnwsXList[subjectIndex].qid
                  )"
                  :key="index"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="
                      getAttachmentsByQid(AnwsXList[subjectIndex].qid).map(
                        v => v.url
                      )
                    "
                    fit="cover"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
          <!-- 证明 -->
          <div
            class="title"
            v-if="subjectType === 'ProofX' && ProofXList.length > 0"
          >
            <div
              v-for="(item, index) in ProofXList[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
            <p class="solve-section">【解析: 】</p>
            <div
              class="solve-section"
              v-for="(item, index) in ProofXList[subjectIndex].solve"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>

            <!-- 证明题附件展示 -->
            <div
              class="attachment-container"
              v-if="
                getAttachmentsByQid(ProofXList[subjectIndex].qid).length > 0
              "
            >
              <div class="attachment-header">
                <i class="el-icon-picture-outline"></i>
                <span>我的附件</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="(file, index) in getAttachmentsByQid(
                    ProofXList[subjectIndex].qid
                  )"
                  :key="index"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="
                      getAttachmentsByQid(ProofXList[subjectIndex].qid).map(
                        v => v.url
                      )
                    "
                    fit="cover"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
          <!-- 底部翻页 -->
          <div class="bottom-nav">
            <el-button class="last" @click="last" type="primary"
              >上一题</el-button
            >
            <div class="line">|</div>
            <el-button class="next" @click="next" type="primary"
              >下一题</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getStudentInfo,
  getOwnTeachingTaskDetail,
  getUserPaperPhotoRecord
} from "@/api/student";
import { convertToFullQuestion } from "@/util/extraction.js";

export default {
  name: "history-detail",
  components: {},
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo") || "{}"),
      examinationSer: "",
      resultList: [],
      str: "\u3000",
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      subjectType: "SingX",
      subjectIndex: 0,
      orderList: [
        { value: 0, label: "A" },
        { value: 1, label: "B" },
        { value: 2, label: "C" },
        { value: 3, label: "D" },
        { value: 4, label: "E" },
        { value: 5, label: "F" },
        { value: 6, label: "G" },
        { value: 7, label: "H" },
        { value: 8, label: "I" }
      ],
      choose: {},
      attachments: {}, // { qid: [fileList] }
      loadingAttachments: false
    };
  },
  computed: {
    currentQuestion() {
      if (this.subjectType === "SingX")
        return this.SingXList[this.subjectIndex];
      if (this.subjectType === "MultX")
        return this.MultXList[this.subjectIndex];
      if (this.subjectType === "JudgX")
        return this.JudgXList[this.subjectIndex];
      if (this.subjectType === "FillX")
        return this.FillXList[this.subjectIndex];
      if (this.subjectType === "AnwsX")
        return this.AnwsXList[this.subjectIndex];
      if (this.subjectType === "ProofX")
        return this.ProofXList[this.subjectIndex];
      return null;
    }
  },
  watch: {
    "currentQuestion.qid": {
      handler(newVal) {
        if (newVal) {
          this.loadQuestionAttachments(newVal);
        }
      },
      immediate: true
    }
  },
  async mounted() {
    this.examinationSer = this.$route.query.title || "";
    await this.getDetail();
    this.firstFunc();
  },
  methods: {
    async getDetail() {
      const taskId = this.$route.params.taskId;

      // 获取用户信息用于展示
      getStudentInfo().then(res => {
        if (res.code === 200 && res.data) {
          const name = res.data.userName || res.data.studentName;
          const no = res.data.studentNo || res.data.userNumber;
          this.userInfo = {
            ...this.userInfo,
            studentName: name,
            studentNo: no
          };
        }
      });

      // 从 localStorage 获取 studentId（与其他页面保持一致）
      const studentId = JSON.parse(localStorage.getItem("userInfo") || "{}")
        .studentId;

      const res = await getOwnTeachingTaskDetail({ studentId, taskId });
      if (res.code !== 200 || !res.data || !res.data.length) {
        this.$message.error("题目加载失败，请返回重试");
        return;
      }

      const list = [];
      res.data.forEach(val => {
        list.push(val.teachingTaskDetail);
        this.resultList.push(val.studentResult);
      });

      const arr = list.map(item => convertToFullQuestion(item));
      this.filterArray(arr);
    },
    filterArray(arr) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let arr1 = [];
      arr.forEach(item => {
        arr1.push(item);
      });
      arr1.filter(item => {
        this.choose = [];
        // 还原答案顺序和学生作答
        let result = this.resultList;
        result.forEach(s => {
          if (s.questionId == item.qid) {
            if (item.subjectType == "SingX" || item.subjectType == "MultX") {
              let orgoptions = item.options;
              item.options = [];
              for (let n = 0; n < s.answerSequences.length; n++) {
                let optid = s.answerSequences[n];
                orgoptions.forEach(optitem => {
                  if (optitem.index == optid) {
                    item.options.push(optitem);
                  }
                });
              }
              item.order = s.answerSequences;
              if (item.subjectType == "MultX") {
                item.answer = s.result.split(",");
              } else {
                item.answer = s.result;
              }
            }
            if (item.subjectType == "JudgX") {
              if (s.result === "0") {
                item.answer = "错误";
                item.hh = 0;
              } else if (s.result === "1") {
                item.answer = "正确";
                item.hh = 1;
              } else {
                item.answer = "";
                item.hh = -1;
              }
            }
          }
        });

        item.usr_choice = item.answer;
        if (item.subjectType == "SingX") {
          let pindex = parseInt(item.answer);
          item.options.forEach((opt, index) => {
            if (opt.index === pindex) {
              switch (index) {
                case 0:
                  item.answer = "A";
                  break;
                case 1:
                  item.answer = "B";
                  break;
                case 2:
                  item.answer = "C";
                  break;
                case 3:
                  item.answer = "D";
                  break;
                case 4:
                  item.answer = "E";
                  break;
                case 5:
                  item.answer = "F";
                  break;
                case 6:
                  item.answer = "G";
                  break;
                case 7:
                  item.answer = "H";
                  break;
                default:
                  break;
              }
            }
          });
        }
        if (item.subjectType == "MultX") {
          item.fill = "";
          item.options.forEach(opt => {
            opt.hh = false;
          });
          item.answer.map(val => {
            let pindex = parseInt(val);
            item.options.forEach((opt, index) => {
              if (opt.index === pindex) {
                opt.hh = true;
                switch (index) {
                  case 0:
                    item.fill = item.fill.concat("A");
                    break;
                  case 1:
                    item.fill = item.fill.concat("B");
                    break;
                  case 2:
                    item.fill = item.fill.concat("C");
                    break;
                  case 3:
                    item.fill = item.fill.concat("D");
                    break;
                  case 4:
                    item.fill = item.fill.concat("E");
                    break;
                  case 5:
                    item.fill = item.fill.concat("F");
                    break;
                  case 6:
                    item.fill = item.fill.concat("G");
                    break;
                  case 7:
                    item.fill = item.fill.concat("H");
                    break;
                  default:
                    break;
                }
              }
            });
          });
        }
      });
      this.SingXList = arr1.filter(item => item.subjectType === "SingX");
      this.MultXList = arr1.filter(item => item.subjectType === "MultX");
      this.JudgXList = arr1.filter(item => item.subjectType === "JudgX");
      this.ProofXList = arr1.filter(item => item.subjectType === "ProofX");
      this.FillXList = arr1.filter(item => item.subjectType === "FillX");
      this.AnwsXList = arr1.filter(item => item.subjectType === "AnwsX");

      this.$nextTick(() => {
        this.setImageWidth();
      });
      loading.close();
    },
    // 默认展示第一个有题目的题型
    firstFunc() {
      if (this.SingXList.length > 0) {
        this.subjectType = "SingX";
        this.subjectIndex = 0;
        return;
      }
      if (this.MultXList.length > 0) {
        this.subjectType = "MultX";
        this.subjectIndex = 0;
        return;
      }
      if (this.JudgXList.length > 0) {
        this.subjectType = "JudgX";
        this.subjectIndex = 0;
        return;
      }
      if (this.FillXList.length > 0) {
        this.subjectType = "FillX";
        this.subjectIndex = 0;
        return;
      }
      if (this.AnwsXList.length > 0) {
        this.subjectType = "AnwsX";
        this.subjectIndex = 0;
        return;
      }
      if (this.ProofXList.length > 0) {
        this.subjectType = "ProofX";
        this.subjectIndex = 0;
      }
    },
    switchItem(type) {
      this.subjectType = type;
      this.subjectIndex = 0;
    },
    singxIndexChange(index) {
      this.subjectIndex = index;
    },
    multxIndexChange(index) {
      this.subjectIndex = index;
    },
    judgexIndexChange(index) {
      this.subjectIndex = index;
    },
    fillxChange(index) {
      this.subjectIndex = index;
    },
    proofxChange(index) {
      this.subjectIndex = index;
    },
    anwsxChange(index) {
      this.subjectIndex = index;
    },
    last() {
      if (this.subjectIndex === 0) return;
      this.subjectIndex--;
    },
    next() {
      let maxIdx = 0;
      if (this.subjectType === "SingX") maxIdx = this.SingXList.length - 1;
      else if (this.subjectType === "MultX") maxIdx = this.MultXList.length - 1;
      else if (this.subjectType === "JudgX") maxIdx = this.JudgXList.length - 1;
      else if (this.subjectType === "FillX") maxIdx = this.FillXList.length - 1;
      else if (this.subjectType === "ProofX")
        maxIdx = this.ProofXList.length - 1;
      else if (this.subjectType === "AnwsX") maxIdx = this.AnwsXList.length - 1;
      if (this.subjectIndex < maxIdx) {
        this.subjectIndex++;
      }
    },
    setImageWidth() {
      let imgs = document.getElementsByTagName("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].className == "subjectImage") {
          imgs[i].style.zoom = "50%";
        }
      }
    },
    // 加载附件记录
    async loadQuestionAttachments(qid) {
      if (!qid || this.loadingAttachments) return;
      this.loadingAttachments = true;
      try {
        const studentId = Number(
          sessionStorage.getItem("studentID") ||
            localStorage.getItem("studentID") ||
            (this.userInfo && (this.userInfo.studentId || this.userInfo.id))
        );
        const taskId = this.$route.params.taskId;
        const res = await getUserPaperPhotoRecord(
          Number(taskId),
          Number(qid),
          studentId
        );
        if (res.code === 200) {
          this.$set(this.attachments, qid, res.data || []);
        }
      } catch (e) {
        console.error("加载附件失败:", e);
      } finally {
        this.loadingAttachments = false;
      }
    },
    getAttachmentsByQid(qid) {
      return this.attachments[qid] || [];
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.analysis-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  min-height: 100vh;
}

.analysis-header {
  height: 60px;
  border-bottom: 2px solid #f8fafb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  background: white;

  .header-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

.page {
  display: flex;
}

.analysis-body {
  flex: 1;
  display: flex;
  gap: 20px;
  background: #f5f7fa !important;
  padding: 20px !important;
  box-shadow: none !important;

  .left-panel {
    width: 280px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .user-profile {
      padding: 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;

      .avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 15px;
        object-fit: cover;
      }

      .user-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .uname {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 6px;
        }
        .uno {
          font-size: 13px;
          color: #909399;
        }
      }
    }

    .nav-collapse {
      flex: 1;
      overflow-y: auto;
      border-top: none;
      padding: 0 10px;

      ::v-deep .el-collapse-item__header {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
        padding-left: 10px;
      }
      ::v-deep .el-collapse-item__wrap {
        border-bottom: none;
      }

      .nav-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 10px;

        .nav-circle {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #f4f4f5;
          color: #606266;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            color: #409eff;
            background: #ecf5ff;
          }

          &.answered {
            background: #f0f9eb;
            color: #67c23a;
          }

          &.active {
            background: #409eff;
            color: white;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
          }
        }
      }
    }
  }

  .right {
    flex: 1;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 30px;
    margin: 0 !important;
    width: auto !important;
    text-align: left;

    .item {
      padding: 0 !important;
      height: auto !important;
      min-height: 200px;

      .title {
        font-size: 24px;
        margin-bottom: 20px;

        img {
          vertical-align: middle;
        }
      }

      .groupbox,
      .groupcheckbox {
        font-size: 20px;
      }
    }
  }
}

.bottom-nav {
  margin-top: 60px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .last,
  .next {
    margin: 0 60px;
    cursor: pointer;
  }

  .line {
    color: #eee;
    margin: 0 10px;
  }
}

.labelbox1 {
  margin-left: 10px;
}

.box {
  font-size: 40px;
}

.student-answer {
  display: inline-block;
  margin-top: 16px;
}

.solve-section {
  font-size: 24px;
}

::v-deep .katex {
  font-size: 24px;
}

::v-deep .el-icon-circle-close:hover {
  color: #409eff;
}

::v-deep .el-icon-circle-check:hover {
  color: #409eff;
}

.correct-option {
  background-color: #ffcccc;
  border-radius: 4px;
  margin: 10px 0;
}

.option-content {
  padding: 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.correct-tag {
  color: #ff4d4f;
  margin-left: 20px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.attachment-container {
  margin-top: 20px;
  width: 100%;
  padding: 15px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  .attachment-header {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .attachment-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }
  }
}
</style>
